// src/redux/api/menuApi.js
import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from '../api/api';
;



export const menuApi = createApi({
  reducerPath: 'menuApi',
  baseQuery: axiosBaseQuery(),
  tagTypes: ['Favorite', 'Address', 'Cart'],
  endpoints: (builder) => ({
    getMenuHome: builder.query({
      query: (restaurant_name) => ({
        url: `api/web/v1/site/merchant-home`,
        method: 'POST',
        data: {
          merchant_id: restaurant_name,
        },
        withToken: false,
      }),
    }),


    getProductById: builder.query({
      query: (productId) => {
        const formData = new FormData();
        formData.append("service_id", productId);

        return {
          url: `api/web/v1/site/service`,
          method: "POST",
          data: formData,
          isFormData: true,
          withToken: false,
        };
      },
    }),

    // New contact endpoint
    submitContactForm: builder.mutation({
      query: (contactData) => {
        const formData = new FormData();
        formData.append("restaurant_id", contactData.restaurant_id);
        formData.append("name", contactData.name);
        formData.append("email", contactData.email);
        formData.append("mobile", contactData.mobile);
        formData.append("message", contactData.message);

        return {
          url: `api/web/v1/site/contact`,
          method: "POST",
          data: formData,
          isFormData: true,
        };
      },
    }),

    // New cart endpoints
    getCart: builder.query({
      query: ({ token, merchant_id }) => {
        const formData = new FormData();
        formData.append("token", token);
        formData.append("merchant_id", merchant_id);

        return {
          url: `api/web/v1/site/cart`,
          method: "POST",
          data: formData,
          isFormData: true,
          withToken: false,
        };
      },
      providesTags: ['Cart'],
    }),

    addToCart: builder.mutation({
      query: (data) => {
        const formData = new FormData();
        Object.keys(data).forEach(key => {
          if (data[key] !== undefined && data[key] !== null) {
            formData.append(key, data[key]);
          }
        });

        return {
          url: `api/web/v1/site/add-to-cart`,
          method: "POST",
          data: formData,
          isFormData: true,
          withToken: false,
        };
      },
      invalidatesTags: ['Cart'],
    }),

    deleteCart: builder.mutation({
      query: ({ cart_id, merchant_id, token }) => {
        const formData = new FormData();
        formData.append("cart_id", cart_id);
        formData.append("merchant_id", merchant_id);
        formData.append("token", token);

        return {
          url: `api/web/v1/site/delete-cart`,
          method: "POST",
          data: formData,
          isFormData: true,
          withToken: false,
        };
      },
      invalidatesTags: ['Cart'],
    }),

    changeQuantity: builder.mutation({
      query: ({ cart_id, quantity, token, merchant_id }) => {
        const formData = new FormData();
        formData.append("cart_id", cart_id);
        formData.append("quantity", quantity);
        formData.append("token", token);
        formData.append("merchant_id", merchant_id);

        return {
          url: `api/web/v1/site/change-quantity`,
          method: "POST",
          data: formData,
          isFormData: true,
          withToken: false,
        };
      },
      invalidatesTags: ['Cart'],
    }),

    getCartNumber: builder.query({
      query: ({ merchant_id, token }) => {
        const formData = new FormData();
        formData.append("merchant_id", merchant_id);
        formData.append("token", token);

        return {
          url: `api/web/v1/site/cart-number`,
          method: "POST",
          data: formData,
          isFormData: true,
          withToken: false,
        };
      },
      providesTags: ['Cart'],
    }),

    // Favorite Endpoints
    getFavoriteProducts: builder.query({
      query: ({ merchant_id, page = 1 }) => {
        const formData = new FormData();
        formData.append("merchant_id", merchant_id);
        formData.append("page", page);

        return {
          url: `api/web/v1/site/product-favorite`,
          method: "POST",
          data: formData,
          isFormData: true,
          tokenType: 'customer',
        };
      },
      providesTags: ['Favorite'],
    }),

    addProductToFavorite: builder.mutation({
      query: ({ merchant_id, product_id }) => {
        const formData = new FormData();
        formData.append("merchant_id", merchant_id);
        formData.append("product_id", product_id);

        return {
          url: `api/web/v1/site/add-product-to-favorite`,
          method: "POST",
          data: formData,
          isFormData: true,
          tokenType: 'customer',
        };
      },
      invalidatesTags: ['Favorite'],
    }),

    deleteProductFromFavorite: builder.mutation({
      query: ({ merchant_id, product_id }) => {
        const formData = new FormData();
        formData.append("merchant_id", merchant_id);
        formData.append("product_id", product_id);

        return {
          url: `api/web/v1/site/product-favorite-delete`,
          method: "POST",
          data: formData,
          isFormData: true,
          tokenType: 'customer',
        };
      },
      invalidatesTags: ['Favorite'],
    }),

    loginMobileApp: builder.mutation({
      query: ({ mobile, merchant_id }) => {
        const formData = new FormData();
        formData.append("mobile", mobile);
        formData.append("merchant_id", merchant_id);

        return {
          url: `api/web/v1/site/login-mobile-app`,
          method: "POST",
          data: formData,
          isFormData: true,
          withToken: false,
        };
      },
    }),

    activateMobile: builder.mutation({
      query: ({ activation_code, merchant_id }) => {
        const formData = new FormData();
        formData.append("activation_code", activation_code);
        if (merchant_id) {
          formData.append("merchant_id", merchant_id);
        }

        return {
          url: `api/web/v1/site/activate-mobile`,
          method: "POST",
          data: formData,
          isFormData: true,
          withToken: false,
        };
      },
    }),

    registerDeviceToken: builder.mutation({
      query: ({ deviceToken, deviceType, merchant_id }) => {
        const formData = new FormData();
        formData.append("deviceToken", deviceToken);
        formData.append("deviceType", deviceType);
        formData.append("merchant_id", merchant_id);

        return {
          url: `api/web/v1/site/device-token-app`,
          method: "POST",
          data: formData,
          isFormData: true,
          tokenType: 'customer',
        };
      },
    }),

    resendCode: builder.mutation({
      query: ({ mobile, merchant_id }) => {
        const formData = new FormData();
        formData.append("mobile", mobile);
        if (merchant_id) {
          formData.append("merchant_id", merchant_id);
        }

        return {
          url: `api/web/v1/site/resend-code`,
          method: "POST",
          data: formData,
          isFormData: true,
          withToken: false,
        };
      },
    }),
    getServiceTypes: builder.query({
      query: (merchant_id) => {
        const formData = new FormData();
        formData.append("merchant_id", merchant_id);

        return {
          url: `api/web/v1/site/service-type`,
          method: "POST",
          data: formData,
          isFormData: true,
          withToken: false,
        };
      },
    }),
    getSiteList: builder.query({
      query: (user_id) => {
        const formData = new FormData();
        formData.append("user_id", user_id);
        formData.append("merchant_id", user_id);

        return {
          url: `api/web/v1/site/list`,
          method: "POST",
          data: formData,
          isFormData: true,
          withToken: false,
        };
      },
    }),
    getSavedAddresses: builder.query({
      query: () => ({
        url: `api/web/v1/site/address`,
        method: "GET",
        tokenType: 'customer',
      }),
      providesTags: ['Address'],
    }),
    checkDiscountCode: builder.mutation({
      query: ({ code, merchant_id }) => {
        const formData = new FormData();
        formData.append('code', code);
        formData.append('merchant_id', merchant_id);
        return {
          url: `api/web/v1/site/check-code-app`,
          method: 'POST',
          data: formData,
          isFormData: true,
          tokenType: 'customer',
        };
      },
    }),
    checkoutOrder: builder.mutation({
      query: (data) => {
        const formData = new FormData();
        Object.keys(data).forEach(key => {
          if (data[key] !== undefined && data[key] !== null) {
            formData.append(key, data[key]);
          }
        });
        return {
          url: `api/web/v1/site/checkout-app`,
          method: "POST",
          data: formData,
          isFormData: true,
          tokenType: 'customer',
        };
      },
      invalidatesTags: ['Cart'],
    }),
    checkDeliveryRange: builder.mutation({
      query: ({ merchant_id, addresslatitude, addresslongitude }) => {
        const formData = new FormData();
        formData.append("merchant_id", merchant_id);
        formData.append("addresslatitude", addresslatitude);
        formData.append("addresslongitude", addresslongitude);

        return {
          url: `api/web/v1/site/delivery-check`,
          method: "POST",
          data: formData,
          isFormData: true,
          withToken: false,
        };
      },
    }),
    getMyOrders: builder.query({
      query: ({ merchant_id, page = 1 }) => {
        const formData = new FormData();
        formData.append("merchant_id", merchant_id);
        formData.append("page", page);

        return {
          url: `api/web/v1/site/my-order`,
          method: "POST",
          data: formData,
          isFormData: true,
          tokenType: 'customer',
        };
      },
    }),
    viewOrder: builder.mutation({
      query: (id) => {
        const formData = new FormData();
        formData.append("id", id);

        return {
          url: `api/web/v1/site/view-order`,
          method: "POST",
          data: formData,
          isFormData: true,
          tokenType: 'customer',
        };
      },
    }),
    getUserInfo: builder.query({
      query: () => ({
        url: `api/web/v1/site/user-info`,
        method: "GET",
        tokenType: 'customer',
      }),
    }),
    updateProfile: builder.mutation({
      query: (profileData) => {
        const formData = new FormData();
        formData.append("name", profileData.name);
        formData.append("email", profileData.email);
        formData.append("mobile", profileData.mobile);

        return {
          url: `api/web/v1/site/profile`,
          method: "POST",
          data: formData,
          isFormData: true,
          tokenType: 'customer',
        };
      },
    }),
    addAddress: builder.mutation({
      query: (addressData) => {
        const formData = new FormData();
        Object.keys(addressData).forEach(key => {
          formData.append(key, addressData[key]);
        });

        return {
          url: `api/web/v1/site/add-address`,
          method: "POST",
          data: formData,
          isFormData: true,
          tokenType: 'customer',
        };
      },
      invalidatesTags: ['Address'],
    }),
    deleteAddress: builder.mutation({
      query: (id) => {
        const formData = new FormData();
        formData.append("id", id);

        return {
          url: `api/web/v1/site/delete-address`,
          method: "POST",
          data: formData,
          isFormData: true,
          tokenType: 'customer',
        };
      },
      invalidatesTags: ['Address'],
    }),
    logout: builder.mutation({
      query: () => ({
        url: `api/web/v1/site/logout`,
        method: "POST",
        tokenType: 'customer',
      }),
    }),
    deleteAccount: builder.mutation({
      query: () => ({
        url: `api/web/v1/site/delete-account`,
        method: "GET",
        tokenType: 'customer',
      }),
    }),
    verifyPayment: builder.mutation({
      query: ({ payment_id, order_id, merchant_id }) => {
        const formData = new FormData();
        formData.append('paymant_id', payment_id); // Intentional spelling per request
        if (order_id)    formData.append('order_id',    order_id);
        if (merchant_id) formData.append('merchant_id', merchant_id);
        return {
          url: `api/web/v1/site/success-fatorah-web`,
          method: 'POST',
          data: formData,
          isFormData: true,
          tokenType: 'customer',
        };
      },
    }),
    getMerchantInfo: builder.query({
      query: (merchant_id) => ({
        url: `api/web/v1/site/merchant-info`,
        method: 'POST',
        data: {
          merchant_id,
          user_id: merchant_id
        },
        withToken: false,
      }),
    }),
    getWorkingTime: builder.query({
      query: (merchant_id) => {
        const formData = new FormData();
        formData.append('merchant_id', merchant_id);
        return {
          url: `api/web/v1/site/working-time`,
          method: 'POST',
          data: formData,
          isFormData: true,
          withToken: false,
        };
      },
    }),
    getMerchantComments: builder.query({
      query: (merchant_id) => {
        const formData = new FormData();
        formData.append('merchant_id', merchant_id);
        return {
          url: `api/web/v1/site/merchant-comment`,
          method: 'POST',
          data: formData,
          isFormData: true,
          withToken: false,
        };
      },
    }),
    addMerchantComment: builder.mutation({
      query: ({ merchant_id, comment, rate }) => {
        const formData = new FormData();
        formData.append('merchant_id', merchant_id);
        formData.append('comment', comment);
        formData.append('rate', rate);
        return {
          url: `api/web/v1/site/add-merchant-comment`,
          method: 'POST',
          data: formData,
          isFormData: true,
          tokenType: 'customer',
        };
      },
    }),
    getNotifications: builder.query({
      query: (merchant_id) => ({
        url: `api/web/v1/site/notification`,
        method: "GET",
        tokenType: 'customer',
        params: merchant_id ? { merchant_id } : undefined
      }),
    }),
    getUnreadNotificationsCount: builder.query({
      query: (merchant_id) => ({
        url: `api/web/v1/site/unread-notification`,
        method: "GET",
        tokenType: 'customer',
        params: merchant_id ? { merchant_id } : undefined
      }),
    }),
  }),
});

export const { 
  useGetMenuHomeQuery, 
  useGetProductByIdQuery, 
  useSubmitContactFormMutation,
  useGetCartQuery,
  useAddToCartMutation,
  useDeleteCartMutation,
  useChangeQuantityMutation,
  useGetCartNumberQuery,
  useGetFavoriteProductsQuery,
  useAddProductToFavoriteMutation,
  useDeleteProductFromFavoriteMutation,
  useLoginMobileAppMutation,
  useActivateMobileMutation,
  useResendCodeMutation,
  useGetServiceTypesQuery,
  useGetSiteListQuery,
  useGetSavedAddressesQuery,
  useCheckDeliveryRangeMutation,
  useCheckDiscountCodeMutation,
  useCheckoutOrderMutation,
  useGetMyOrdersQuery,
  useViewOrderMutation,
  useGetUserInfoQuery,
  useUpdateProfileMutation,
  useAddAddressMutation,
  useDeleteAddressMutation,
  useLogoutMutation,
  useDeleteAccountMutation,
  useVerifyPaymentMutation,
  useGetMerchantInfoQuery,
  useGetWorkingTimeQuery,
  useGetMerchantCommentsQuery,
  useAddMerchantCommentMutation,
  useGetNotificationsQuery,
  useGetUnreadNotificationsCountQuery,
  useRegisterDeviceTokenMutation,
} = menuApi;
